import { callPromiseAssert } from "../../shared/util/callPromiseAssert";
import { viewJobNativeModule } from "./ViewJobNativeModule";

export function httpPostJson<T>(url: string, payload: string): Promise<T> {
  return callPromiseAssert(viewJobNativeModule()?.httpPostJson<T>, "httpPostJson", url, payload);
}
